import { Button } from '@thanx/uikit/button'
import { Switch } from '@thanx/uikit/switch'
import { buildTranslate } from 'locales'
import React, { useCallback, useMemo } from 'react'
import { SlideDescription } from 'scenes/Cms/components/Blocks/FeaturedContentCarousel/SlideDescription'
import { ContentBlockData } from 'slices/appLandingPageTheme/types'
import { useFeaturedContentCarousel } from '../hooks'
import ConfigurationInfo from './ConfigurationInfo'
import Description from './Description'

const t = buildTranslate(
  'cms.content.app_home_page.content.block_item.featured_content_carousel'
)

export type FeaturedContentCarouselProps = {
  data: ContentBlockData
  onEdit: VoidFunction
  carouselId: string
}

export const FeaturedContentCarouselDescription = ({
  data,
  onEdit,
  carouselId,
}: FeaturedContentCarouselProps) => {
  const { addSlideToCarousel } = useFeaturedContentCarousel()

  // Sort featured contents by position
  const sortedSlides = useMemo(() => {
    if (
      data.type !== 'featured_content_carousel' ||
      !('featured_contents' in data)
    )
      return []

    const featured_contents = data.featured_contents
    if (!featured_contents) return []

    return Object.entries(featured_contents)
      .map(([slideId, slideData]: [string, any]) => ({
        slideId,
        slideData,
        position: slideData?.position || 0,
      }))
      .sort((a, b) => a.position - b.position)
  }, [data])

  const handleAddSlide = useCallback(() => {
    addSlideToCarousel(carouselId)
    onEdit()
  }, [addSlideToCarousel, onEdit, carouselId])

  if (data.type !== 'featured_content_carousel') return null

  const { featured_contents } = data

  return (
    <>
      {(!featured_contents || Object.keys(featured_contents).length === 0) && (
        <Description type={data.type} />
      )}
      <Switch
        condition={Boolean(
          featured_contents && Object.keys(featured_contents).length > 0
        )}
        fallback={
          <Button className="mt-m" onClick={handleAddSlide}>
            {t('add_slide')}
          </Button>
        }
      >
        <div>
          {sortedSlides.map(({ slideId, slideData }, index) => {
            return (
              <SlideDescription key={slideId} slide={slideData} index={index} />
            )
          })}
        </div>
      </Switch>
      <ConfigurationInfo contentBlock={data} />
    </>
  )
}

export default FeaturedContentCarouselDescription
